import { ChangeDetectorRef, Directive, effect, inject } from '@angular/core';
import { InputText } from 'primeng/inputtext';

@Directive({
  selector: '[appPrimengInputText]',
  standalone: true,
})
export class PrimengInputTextDirective {
  private readonly inputText = inject(InputText);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  private readonly initialClassList = this.getStyleClassList();

  public constructor() {
    effect(() => this.configureInputStyles());
  }

  private configureInputStyles(): void {
    const styles = [...this.initialClassList];

    const element = this.inputHtmlElement();

    element.className = '';
    element.classList.add(...styles);
    this.changeDetectorRef.detectChanges();
  }

  private getStyleClassList(): string[] {
    const { classList } = this.inputHtmlElement();

    return Array.from(classList);
  }

  private inputHtmlElement(): HTMLInputElement {
    return this.inputText.el.nativeElement;
  }
}
